import React from "react";
import { getOpenVtrTrips } from "../../actions/vtrTripStorage";
import { Box, Button, Grid } from "@mui/material";
import { dateSavedToDisplay } from "../../constants/vtrTrip";
import { Link } from "react-router-dom";
import "./HomePage.css";
import DesktopView from "./HPDesktop";
import { useViewport } from "../../components/CustomHooks/useViewport";
import { tripStatusToDisplay } from "../../constants/TripStatus";
import { useSelector } from "react-redux";
import Spinner from "../../components/common/Spinner";

const fontSize = window.innerWidth < 750 ? "small" : "medium";

export default function HomePage(props) {
  const {
    auth: { client_id, user_full_name },
    vtrTrip: { loadingTrips },
  } = useSelector((state) => state);
  let userName = user_full_name;
  const width = useViewport();
  const isMobile = width < 620;
  const openTrips = getOpenVtrTrips(client_id, null, true);

  function getEffortText(NrEfforts) {
    let effortText = NrEfforts.toString() + " effort";

    if (NrEfforts > 1) {
      effortText = effortText + "s";
    }
    return effortText;
  }

  if (loadingTrips) {
    return <Spinner />;
  }

  return (
    <Box mt={3} width="100%" align="center">
      <h3 className="center margBot20">
        You are logged in as: <br /> {userName}
      </h3>
      {openTrips.length > 0 &&
        (isMobile ? (
          openTrips
            .sort((a, b) => b.date_sail.localeCompare(a.date_sail))
            .sort((a, b) => b.trip_id.localeCompare(a.trip_id))
            .map(function (value, index) {
              return (
                <div key={"open_trips_" + index}>
                  <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={5}>
                      <Box m={1} width="90%">
                        <Button
                          variant="contained"
                          style={{ backgroundColor: "#5499C7" }}
                          fullWidth
                        >
                          <Link
                            to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
                            state={{
                              trip_id: value.trip_id,
                              client_id: client_id,
                            }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-start"
                              alignItems="center"
                            >
                              <Grid item xs={5} align="left" className={"colorWhite"}>
                                Trip:
                              </Grid>
                              <Grid item xs={7} align="left" className={"colorWhite"}>
                                {value.submission_type.toUpperCase() === "PAPER"
                                  ? value.lowest_serial_num
                                  : value.trip_id}
                              </Grid>

                              <Grid item xs={5} align="left" className={"colorWhite"}>
                                Date sailed:
                              </Grid>
                              <Grid item xs={7} align="left" className={"colorWhite"}>
                                {value.date_sail
                                  ? dateSavedToDisplay(value.date_sail)
                                  : "No date provided"}
                              </Grid>

                              <Grid item xs={5} align="left" className={"colorWhite"}>
                                Efforts:
                              </Grid>
                              <Grid item xs={7} align="left" className={"colorWhite"}>
                                {value.images && value.images.length > 0
                                  ? getEffortText(value.images.length)
                                  : "No Efforts on File"}
                              </Grid>
                              <Grid item xs={5} align="left" className={"colorWhite"}>
                                Status:
                              </Grid>
                              <Grid item xs={7} align="left" className={"colorWhite"}>
                                {tripStatusToDisplay(value.trip_status)}
                              </Grid>
                            </Grid>
                          </Link>
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </div>
              );
            })
        ) : (
          <DesktopView clientId={client_id} trips={openTrips} />
        ))}
      <p style={{ margin: "10px", textAlign: "left", fontSize: fontSize }}>
        This app is made for owners and operators of federally regulated fishing vessels
        in the Greater Atlantic Region of the USA who are required to submit Vessel Trip
        Report (VTR) reports and/or IVR reports based on their Federal Fishing Permit,
        Exempted Fishing Permit or Research Set-Aside program. This is a free service
        provided by NOAA Fisheries. This is an official app from NOAA Fisheries and
        reporting through this app constitutes regulatory compliance. All data is
        submitted directly and securely to NOAA Fisheries Greater Atlantic Regional
        Fisheries Office (GARFO). Use of this app complies with any GARFO mandated
        requirement for electronic reporting (eVTR / IVR). Users must contact NOAA
        Fisheries at <a href="tel:9782819188">978-281-9188</a> for credentials to use this
        app.
        <br />
        <b style={{ color: "red" }}>
          For Lobster or Jonah Crab trips, please select the new "Commercial - Lobster /
          Jonah Crab" trip type.
        </b>
      </p>
    </Box>
  );
}
